// Shopping opens immediately; the former entrance assets remain available for rollback.
(() => {
  const entrance = document.getElementById('CollectiveEntrance');
  if (entrance) entrance.hidden = true;
  document.body.classList.remove('entrance-active');
  const shop = document.getElementById('StoreShell');
  if (shop) { shop.inert = false; shop.removeAttribute('aria-hidden'); }
})();
